import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeDayZone'
})
export class TimeDayZonePipe implements PipeTransform {

  transform(inputDate: any, ...args: any[]): any {
    const currentDate = new Date();
    const yesterdayDate = new Date(currentDate);
    yesterdayDate.setDate(currentDate.getDate() - 1);

    if (new Date(inputDate).getFullYear() == currentDate.getFullYear() && new Date(inputDate).getMonth() == currentDate.getMonth() && 
    new Date(inputDate).getDate() == currentDate.getDate()){
      return "Today"+ ',' + (new DatePipe("en-US")).transform(new Date(inputDate), 'h:mm a');
    } else if (new Date(inputDate).getFullYear() == yesterdayDate.getFullYear() && new Date(inputDate).getMonth() == yesterdayDate.getMonth() &&
    new Date(inputDate).getDate() == yesterdayDate.getDate()){
      return "Yesterday"+ ',' + (new DatePipe("en-US")).transform(new Date(inputDate), 'h:mm a');
    } else{
      return (new DatePipe("en-US")).transform(new Date(inputDate), 'EEEE, h:mm a');
  }
  }

}
